import React, { useContext, useEffect, useRef, useState } from 'react';

import { toast } from 'react-toastify';
import { AppContext } from '../../../../../contexts/AppContext';
import useWarehouseStorageService from '../../../../../app/services/hooks/useWareHouseQuoteStorageService';
import { WarehouseQuoteStorageDataForm, WarehouseQuoteStorageShowDataForm } from '../../../../../app/models/WareHouseQuoteStorage';
import { ServiceResponse } from '../../../../../app/services/shared/interfaces';
import LazyLoading from '../../../../../components/LazyLoading';
import WarehouseQuoteStorageShowForm from './forms/WareHouseStorageForms/WareHouseStorageShowForm';
import ButtonSaveForm from '../../../../../components/buttons/ButtonSaveForm';
import ButtonCancelForm from '../../../../../components/buttons/ButtonCancelForm';
import DefaultCard from '../../../../../components/default/DefaultCard';

interface Props {
    storageId: number;
    onSaved?: () => void;
    onCancel: () => void;
    onError?: () => void;
}

const WarehouseQuoteStorageShow = ({
    storageId,
    onSaved,
    onCancel,
    onError
}: Props) => {
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);
    const {showWarehouseQuoteStorage, fetchingShowWarehouseQuoteStorage} =
        useWarehouseStorageService();

    const [showStorage, setShowStorage] = useState<WarehouseQuoteStorageShowDataForm>({});

    useEffect(() => {
        show();
    }, [storageId]);

    const show = () => {
        showWarehouseQuoteStorage(storageId, {
                onSuccess: (response: ServiceResponse) => {
                    setShowStorage(response.data.storage);
                },
        });
    };

    return (

        <>
            {!fetchingShowWarehouseQuoteStorage ? (
                <>
                    <WarehouseQuoteStorageShowForm
                        storageform={showStorage}
                    />
                </>
            ) : (
                <LazyLoading />
            )}
        </>
    );
};

export default WarehouseQuoteStorageShow;
